import { useGetMembershipGroup } from 'src/features/memberships/api/useGetMembershipGroup';
import { useListMembershipGroups } from 'src/features/memberships/api/useListMembershipGroups';
import { MembershipGroupDashboard } from 'src/features/memberships/components/MembershipGroupDashboard';
import { MembershipGroupsTable } from 'src/features/memberships/components/table/MembershipGroupsTable';
import { MEMBERSHIP_ROLES } from 'src/features/userManagement/types';
import usePagination from 'src/hooks/usePagination';
import useSorting from 'src/hooks/useSorting';
import { MembershipVehicleLayoutContextProvider } from 'src/providers/MembershipVehiclesLayoutProvider.tsx';
import { useParking } from 'src/providers/ParkingProvider';

const ClientDashboard = () => {
    const { parkingRole, parkingId } = useParking();

    const { querySortingOptions, ...sorting } = useSorting({
        initialSortingState: [{ id: 'id', desc: true }],
    });
    const { queryPaginationOptions, ...pagination } = usePagination();

    const {
        data: membershipGroups,
        isLoading: isLoadingMembershipGroups,
        isError: isErrorMembershipGroups,
        refetch: refetchMembershipGroups,
    } = useListMembershipGroups({
        ...queryPaginationOptions,
        ...querySortingOptions,
        parkingId: parkingId,
        reservation_type: 'NORMAL',
    });

    const {
        data: membershipGroup,
        isLoading: isLoadingMembershipGroup,
        refetch: refetchMembershipGroup,
    } = useGetMembershipGroup({
        parkingId: parkingId || '',
        membershipGroupId: membershipGroups?.results[0]?.id || -1,
        config: { enabled: !!membershipGroups && !!parkingId },
    });

    return (
        <>
            <MembershipVehicleLayoutContextProvider>
                <MembershipGroupDashboard
                    membershipGroup={membershipGroup}
                    isLoadingMembershipGroup={isLoadingMembershipGroup}
                    refetchMembershipGroup={refetchMembershipGroup}
                />
            </MembershipVehicleLayoutContextProvider>

            {parkingRole === MEMBERSHIP_ROLES.CLIENT && (membershipGroups?.count || 0) <= 1 ? (
                <></>
            ) : (
                <MembershipGroupsTable
                    membershipGroups={membershipGroups}
                    isLoadingMembershipGroups={isLoadingMembershipGroups}
                    isErrorMembershipGroups={isErrorMembershipGroups}
                    refetchMembershipGroups={refetchMembershipGroups}
                    sorting={sorting}
                    pagination={pagination}
                />
            )}
        </>
    );
};

export { ClientDashboard };
